import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { fromEvent, Observable } from 'rxjs';
import { AuthState } from 'src/app/services/auth/auth.model';
import { ToastService } from 'src/app/services/toast/toast.service';
import { FieldFacilityBLL } from '../field-facility.bll';
import { AuthService } from 'src/app/services/auth/auth.service';
import { debounceTime, distinctUntilChanged, filter, skipWhile, take, tap } from 'rxjs/operators';
import { search_location } from 'src/app/components/calendar/calendar.model';

@Component({
  selector: 'app-facility-modal',
  templateUrl: './facility-modal.component.html',
  styleUrls: ['./facility-modal.component.scss'],
})
export class FacilityModalComponent implements OnInit, AfterViewInit {

  @ViewChild('search_locations_term') search_locations_term: ElementRef;

  groupForm: FormGroup;
  isLoading$: Observable<boolean>;
  updateGroupLoading$: Observable<boolean>;
  isAddFacilityModelOpen$: Observable<boolean>;
  isLocationsSearchLoading$: Observable<boolean>;
  search_location_results$: Observable<search_location[]>;

  addGroupModal: boolean = false;
  updateFacilityModal: boolean = false;

  // Location overlay state
  add_location_overlay: boolean = false;
  search_location_text: string = '';
  selected_location: search_location = null;

  user: AuthState;
  selectedFacility: any;

  get selected_account() {
    return localStorage.getItem('selected_account') ? localStorage.getItem('selected_account') : '1';
  }

  get ad_admin_id() {
    return localStorage.getItem('ad_admin_id');
  }



  constructor(
    private fb: FormBuilder,
    private toast: ToastService,
    private bll: FieldFacilityBLL,
    private auth: AuthService
  ) {
    this.groupForm = this.fb.group({
      label: ['', [Validators.required]],
      address: ['', [Validators.required]],
      memo: ['', [Validators.required]]
    });
  }

  ngOnInit() {
    this.bll.selectedFacility$.subscribe(facility => {
      if (facility) {
        this.selectedFacility = facility;
        this.label?.setValue(facility.label ?? '');
        this.address?.setValue(facility.address ?? '');
        this.memo?.setValue(facility.memo ?? '');
        // Pre-populate selected_location so the display chip shows existing address
        if (facility.address) {
          this.selected_location = { address: facility.address };
        }
      }
    });
    this.bll.isUpdateFacilityModelOpen$.subscribe(isUpdate => {
      this.updateFacilityModal = isUpdate;
    });

    this.isAddFacilityModelOpen$ = this.bll.isAddFacilityModelOpen$;
    this.isLocationsSearchLoading$ = this.bll.isLocationsSearchLoading$;
    this.search_location_results$ = this.bll.search_locations_response$;

    this.auth.auth$.pipe(skipWhile((val) => !val.token), take(1))
      .subscribe((val) => {
        this.user = val;
        if (this.user.id) {
          this.initObservables();
        }
      });
  }

  ngAfterViewInit() {
    if (this.search_locations_term?.nativeElement) {
      fromEvent(this.search_locations_term.nativeElement, 'keyup')
        .pipe(
          filter(Boolean),
          debounceTime(150),
          distinctUntilChanged(),
          tap(() => {
            this.search_location(this.search_location_text);
          })
        ).subscribe();
    }
  }

  initObservables() {
    this.isLoading$ = this.bll.isLoading$;
  }

  resetModalState() {
    this.groupForm.reset();
    this.selected_location = null;
    this.search_location_text = '';
    this.add_location_overlay = false;
    this.bll.reset_search_location_response();
  }

  /** Called when the user picks an address from the dropdown */
  select_location(location: search_location | null) {
    if (location) {
      this.selected_location = location;
      this.address?.setValue(location.address);
    } else {
      // Cancelled without picking
      this.selected_location = null;
      this.address?.setValue('');
    }
    this.add_location_overlay = false;
    this.search_location_text = '';
    this.bll.reset_search_location_response();
  }

  /** Opens the search overlay when user wants to change/add address */
  open_location_overlay() {
    this.add_location_overlay = true;
  }

  search_location(search: string) {
    if (search && search.trim().length > 0) {
      this.bll.search_locations(search);
    }
  }

  updateFacility() {

    this.bll.editFacility(
      this.selectedFacility.id, this.groupForm.value, this.selected_account == '2' ? this.ad_admin_id : null
    );
    this.resetModalState()
    this.bll.changeUpdateFacilityModelOpen(false);
    this.bll.toggleAddFacilityModel(false);
  }

  createFacility() {
    this.bll.createFacility(
      this.groupForm.value, this.selected_account == '2' ? this.ad_admin_id : null
    );
    this.resetModalState()
    this.bll.toggleAddFacilityModel(false);
  }

  closeModel(isOpen: boolean) {
    this.bll.toggleAddFacilityModel(isOpen);
    this.resetModalState()
    this.bll.changeUpdateFacilityModelOpen(false);
  }

  //#region FORM GETTERS

  get label() {
    return this.groupForm.get('label');
  }

  get address() {
    return this.groupForm.get('address');
  }

  get memo() {
    return this.groupForm.get('memo');
  }

  //#endregion FORM GETTERS

}
